


























































































































































































import { computed, defineComponent } from '@vue/composition-api';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import SuccessCard from '@front-app/components/cards/state/SuccessCard.vue';
import { Size, Spacing } from '@front-app/components/constants';
import HelpTooltipBlock from '@front-app/components/dropdowns/HelpTooltipBlock.vue';
import TrForm from '@front-app/components/form/Form.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import TrCheckbox from '@front-app/components/inputs/Checkbox.vue';
import RadioButton from '@front-app/components/inputs/RadioButton.vue';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import ColumnHeader from '@front-app/components/layouts/columns/ColumnHeader.vue';
import { Routes } from '@front-app/constants/routes';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { useAdminAccess } from '@front-app/modules/group/hooks/useAdminAccess';
import { AdminSettings } from '@front-app/services/GroupsApi/GroupModel';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import { GroupSettingsStore } from '@front-app/store/singletons/GroupSettings';
import {
	areModeratorNotificationsAvailable,
	areModeratorDiscussionNotificationsAvailable,
	areModeratorFileNotificationsAvailable,
} from '@front-app/util/permission';
import { syncedRef } from '@front-app/util/reactivity';

export default defineComponent({
	components: {
		ColumnContainer,
		ColumnHeader,
		CtaButton,
		ErrorCard,
		FormSection,
		HelpTooltipBlock,
		RadioButton,
		SimpleCard,
		SuccessCard,
		TrCheckbox,
		TrForm,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const group = computed(() => GroupsStore.getInstance().groupById(props.groupId));
		const { hasNotificationSettingsAccess } = useAdminAccess(group);

		const settings = computed(() => {
			if (!group.value?.adminSettings) {
				throw Error('Notification settings are missing.');
			}
			return group.value.adminSettings;
		});

		// Member notifications
		const notifyAllMembersDiscussionEnabled = syncedRef(() => settings.value.notifyAllMembersDiscussionEnabled).ref;
		const notifyAllMembersDiscussionDefault = syncedRef(() => settings.value.notifyAllMembersDiscussionDefault).ref;
		const notifyAllMembersFileEnabled = syncedRef(() => settings.value.notifyAllMembersFileEnabled).ref;
		const notifyAllMembersFileDefault = syncedRef(() => settings.value.notifyAllMembersFileDefault).ref;

		const toggleDiscussionNotifications = () => {
			notifyAllMembersDiscussionEnabled.value = !notifyAllMembersDiscussionEnabled.value;
			if (!notifyAllMembersDiscussionEnabled.value) {
				notifyAllMembersDiscussionDefault.value = false;
			} else {
				notifyAllMembersDiscussionDefault.value = settings.value.notifyAllMembersDiscussionDefault;
			}
		};
		const toggleFileNotifications = () => {
			notifyAllMembersFileEnabled.value = !notifyAllMembersFileEnabled.value;
			if (!notifyAllMembersFileEnabled.value) {
				notifyAllMembersFileDefault.value = false;
			} else {
				notifyAllMembersFileDefault.value = settings.value.notifyAllMembersFileDefault;
			}
		};
		// Member notifications

		// Moderator notifications
		const areModeratorSettingsAvailable = computed(() => areModeratorNotificationsAvailable(group.value));
		const areModeratorDiscussionSettingsAvailable = computed(() => areModeratorDiscussionNotificationsAvailable(group.value));
		const areModeratorFileSettingsAvailable = computed(() => areModeratorFileNotificationsAvailable(group.value));

		const notifyModeratorsAllDiscussions = syncedRef(() => settings.value.notifyModeratorsAllDiscussions).ref;
		const notifyModeratorsNewFiles = syncedRef(() => settings.value.notifyModeratorsNewFiles).ref;
		// END Moderator notifications

		// Submission
		const {
			track,
			isError,
			isSuccess,
			isLoading,
		} = useAsyncStatus();

		const changeSettings = async () => {
			const payload: AdminSettings = {
				notifyAllMembersDiscussionEnabled: notifyAllMembersDiscussionEnabled.value,
				notifyAllMembersDiscussionDefault: notifyAllMembersDiscussionDefault.value,
				notifyAllMembersFileEnabled: notifyAllMembersFileEnabled.value,
				notifyAllMembersFileDefault: notifyAllMembersFileDefault.value,
				notifyModeratorsAllDiscussions: notifyModeratorsAllDiscussions.value,
				notifyModeratorsNewFiles: notifyModeratorsNewFiles.value,
			};

			await track(GroupSettingsStore.update(payload, props.groupId));
		};
		// END Submission

		return {
			hasNotificationSettingsAccess,
			GROUP_MAIN_ROUTE: Routes.GROUP_MAIN,
			// Member notifications
			notifyAllMembersDiscussionEnabled,
			notifyAllMembersDiscussionDefault,
			notifyAllMembersFileEnabled,
			notifyAllMembersFileDefault,
			toggleDiscussionNotifications,
			toggleFileNotifications,
			// Moderator notifications
			areModeratorSettingsAvailable,
			areModeratorDiscussionSettingsAvailable,
			areModeratorFileSettingsAvailable,
			notifyModeratorsAllDiscussions,
			notifyModeratorsNewFiles,
			// Submission
			isError,
			isSuccess,
			isLoading,
			changeSettings,
			// Util
			ButtonPalettes,
			Size,
			Spacing,
		};
	},
});
